import { Component, input, output } from '@angular/core';

@Component({
  selector: 'lib-textarea-input',
  templateUrl: './textarea-input.component.html',
})
export class TextareaInputComponent {
  public readonly inputId = input<string>();

  public readonly value = input<string>();

  public readonly placeholder = input<string>();

  public readonly rows = input(4);

  public readonly mono = input(false);

  public readonly changed = output<string>();

  applyValue(event: Event): void {
    this.changed.emit((event.target as HTMLTextAreaElement).value);
  }
}
